import useGetPermission from "../../../hooks/useGetPermission";

const NavigateWithPermission = ({
  children,
  permissionParentKey,
  permissionChildKey,
  showOnLocalSetup = false,
}) => {
  const { isPermitted } = useGetPermission({
    permissionParentKey,
    permissionChildKey,
    showOnLocalSetup,
  });

  return isPermitted ? <>{children}</> : null;
};
export default NavigateWithPermission;
